const defaultState = {
  isPromptModalVisible: false,
  comingSoonDetails: {
    title: '',
    visible: false
  }
};

const globalModalsState = (state = defaultState, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'SHOW_PROMPT_MODAL':
      return {
        ...state,
        isPromptModalVisible: payload.isPromptModalVisible
      };

    case 'SHOW_COMING_SOON': {
      const { title, visible } = payload.comingSoonDetails;

      return {
        ...state,
        comingSoonDetails: {
          title: title,
          visible
        }
      };
    }

    default:
      return { ...state };
  }
};

export default globalModalsState;
